import React from 'react';
import ResponsiveWrapper from '../../../components/ResponsiveWrapper';
import StandardInfo_Dtail from './index';
import MobileStandardInfo_Detail from './MobileStandardInfo_Detail';

const ResponsiveStandardInfo_Dtail = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileStandardInfo_Detail />}
      desktop={<StandardInfo_Dtail />}
    />
  );
};

export default ResponsiveStandardInfo_Dtail;